import React from "react";
import { find } from "lodash";
import WebComponent from "../../Util/WebComponent";
import { withRedux, getTextColor } from "helpers";
import styled from "react-emotion";

const PageContainer = styled("div")`
  padding: 0.1em;
  background-color: ${(props) =>
    props.backgroundColor ? props.backgroundColor : "white"};
  border-radius: 5px;
  display: flex;
  justify-content: center;
  align-items: center;
  box-shadow: 3px 3px 13px rgba(120, 120, 120, 0.5);
  @media only screen and (min-width: 500px) {
    padding: 1em;
  }
`;

function ImageGalleryWebComponent(props) {
  const {
    activeTemplate: { backgroundColor, backgroundImage, components },
  } = props;

  const catalog = find(components, { componentNumber: 1 });

  const textColor = getTextColor(backgroundColor);

  return (
    <PageContainer
      backgroundColor={backgroundColor}
      backgroundImage={backgroundImage}
    >
      <WebComponent {...catalog} textColor={textColor} />
    </PageContainer>
  );
}

export default withRedux(ImageGalleryWebComponent);
